<!--
 * @Description: 历史记录弹框
 * @Author: black-k
 * @Date: 2025-09-12 10:58:28
 * @LastEditors: black-k
 * @LastEditTime: 2025-09-18 17:01:42
-->
<template>
    <div class="basic-dialog task-dialog history-dialog">
        <el-dialog
            :title="`第${index}次提交历史记录`"
            :visible="visible"
            @update:visible="handleUpdateVisible"
            width="1220px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <el-scrollbar class="dialog-scrollbar">
                <PlanItem
                    :plan="plan"
                    :operates="false"
                    :task-mode="mode"
                    :history="false"
                    :shadow="false"
                    :user-id="userId"
                    v-if="plan"
                ></PlanItem>
            </el-scrollbar>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "HistoryDialog",

    data() {
        return {};
    },

    props: {
        visible: {
            type: Boolean,
            required: true,
        },

        index: {
            type: Number,
            required: true,
        },

        plan: {
            type: Object,
        },

        mode: {
            type: Number,
            default: 1,
        },
        userId: {
            type: Number,
        },
    },

    components: {
        PlanItem: () => import("../apply/PlanItem.vue"),
    },

    methods: {
        handleUpdateVisible(val) {
            this.$emit("update:visible", val);
        },
    },
};
</script>

<style lang="scss" scoped>
.history-dialog {
    .dialog-scrollbar {
        ::v-deep .el-scrollbar__wrap {
            max-height: 1000px;
            margin: 0 !important;
            padding: 0 0 20px;

            &::-webkit-scrollbar {
                display: none;
            }

            .el-scrollbar__view {
                padding: 0;
            }
        }

        .plan-item {
            margin-top: 0;
        }
    }
}
</style>
